import React, { FC } from 'react'
import cn from 'classnames'
import numeral from 'numeral'
import { Classes } from '@blueprintjs/core'
import { DivProps } from '@commonTypes'
import css from './heroCards.module.scss'

interface IProps {
  children?: React.ReactNode
  cards?: IValueProps[]
}
const HeroCards = ({ children, cards }: IProps) => {
  return (
    <div className={css.s_container}>
      {children}
      {cards?.map((c, i) => (
        <Card key={i} {...c} />
      ))}
    </div>
  )
}

interface IValueProps {
  value?: number
  label?: string
  format?: string
  fontSize?: number
}
export function Card({ value, label, format = '0[.]0a', fontSize = 42 }: IValueProps) {
  if (value === undefined) return <div className={`${css.s_placeholder} ${Classes.SKELETON}`} />
  return (
    <div className={css.s_card}>
      <SValue fontSize={fontSize}>{numeral(value).format(format)}</SValue>
      {Boolean(label) && <div className={css.s_label}>{label}</div>}
    </div>
  )
}
HeroCards.Card = Card
export default HeroCards

interface ISValue {
  fontSize: number
}

const SValue: FC<React.PropsWithChildren<DivProps & ISValue>> = ({
  fontSize,
  className,
  style,
  ...props
}) => {
  return (
    <div
      className={cn(css.s_value, className)}
      style={{ fontSize: fontSize, ...style }}
      {...props}
    />
  )
}
